import { NoddiButton } from '../../Inputs/NoddiButton';
import { NoddiInfoBanner } from '../NoddiInfoBanner';
import { ErrorPageBaseProps } from './types';

export const ErrorPageBase = ({ title, description, buttonProps }: ErrorPageBaseProps) => (
  <div className='mx-auto flex min-h-[60vh] max-w-2xl flex-col items-center justify-center p-4 text-center md:p-10'>
    <NoddiInfoBanner variant='error' title={title} texts={[{ value: description }]} />
    {buttonProps && (
      <NoddiButton onClick={buttonProps.onButtonClick} className='mt-5'>
        {buttonProps.buttonText}
      </NoddiButton>
    )}
  </div>
);
